/**
 * Classifica falhas de bootstrap/API para telas de estado amigáveis.
 * Observação: `fetchData` lança Error com `.status` (sem `.response` do Axios).
 * @returns {"offline"|"permission"|"session"|"generic"}
 */
export function classifyApiLoadError(error) {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return "offline";
  }

  if (!error) return "generic";

  const statusRaw = error?.status ?? error?.response?.status;
  const status =
    statusRaw != null && statusRaw !== "" && Number.isFinite(Number(statusRaw))
      ? Number(statusRaw)
      : null;
  const code = String(error?.code || error?.response?.data?.code || "").toUpperCase();
  const message = String(error?.message || error?.response?.data?.message || "").toLowerCase();

  if (status === 401 || code === "UNAUTHORIZED" || message.includes("não autenticado")) {
    return "session";
  }

  // Impersonação platform/partner sem usuário no tenant — não é "cargo" do workspace.
  const rawCode = String(error?.code || error?.response?.data?.code || error?.response?.data?.data?.code || "");
  if (
    rawCode === "errors.auth.platform_no_tenant_user" ||
    rawCode === "errors.auth.partner_no_tenant_user"
  ) {
    return "permission";
  }

  if (
    status === 403 ||
    code === "FORBIDDEN" ||
    /permiss[aã]o|forbidden|acesso negado|não autorizado|sem permiss/.test(message)
  ) {
    return "permission";
  }

  if (status === 502 || status === 503 || status === 504 || (status != null && status >= 500)) {
    return "offline";
  }

  const looksLikeNetworkCode =
    code === "ERR_NETWORK" ||
    code === "ECONNABORTED" ||
    code === "ETIMEDOUT" ||
    code === "ECONNREFUSED" ||
    code === "ECONNRESET";

  const looksLikeNetworkMessage =
    /network error|timeout|failed to fetch|err_network|econnrefused|econnreset|net::/.test(
      message
    );

  if (status == null && (looksLikeNetworkCode || looksLikeNetworkMessage || error?.request)) {
    return "offline";
  }

  if (status == null && !error?.response && looksLikeNetworkCode) {
    return "offline";
  }

  return "generic";
}

export function isPermissionsAccessDenied(error) {
  return classifyApiLoadError(error) === "permission";
}

export function isAppOfflineOrLoadError(error) {
  const kind = classifyApiLoadError(error);
  return kind === "offline" || kind === "generic";
}
